var map = {
	"./dark/share/01home/07bg.png": "CD7K",
	"./light/share/01home/07bg.png": "fQf8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ERdI";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme ^\.\/.*\/share\/01home\/07bg\.png$
// module id = ERdI
// module chunks = 0